export default {
  domain: AUTH0_DOMAIN,
  client_id: AUTH0_CLIENT_ID,
  base_url: BASE_URL || "https://api.originmedia.tv",
  version: VER || "1.0.0",
  environment: ENV || "local",
  auth0_mgt_token: AUTH0_MANAGEMENT_TOKEN || "",
};
